/**
 * Formlardaki sayı kutuları 0 ile başlıyor; kutuya tıklanınca 0 silinir ki kullanıcı doğrudan
 * yazmaya başlayabilsin (aksi halde "0480266" gibi değerler oluşuyordu).
 * Hiçbir şey yazmadan çıkılırsa React, formdaki değeri (0) bir sonraki çizimde geri yazar.
 */
export const clearZeroOnFocus = () => {
  document.addEventListener('focusin', (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || input.readOnly || input.disabled) {
      return;
    }
    const isNumeric = input.type === 'number' || input.inputMode === 'numeric' || input.inputMode === 'decimal';
    if (isNumeric && /^0([.,]0+)?$/.test(input.value)) {
      input.value = '';
    }
  });
};
